import { useEffect, useState } from "react";
import LoaderHelper from "../../secondaryComponents/LoaderHelper/LoaderHelper";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";
import { isCashierUser } from "../../../helpers";

export const CashierRestriction = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isCashierUser()) return navigate(pathConstants.CASHIER_STORES);

    setIsLoading(false);
  }, []);

  return (
    <LoaderHelper isLoading={isLoading} classNames="mt-5">
      {children}
    </LoaderHelper>
  );
};
